export interface CostDto {
  amount: number;
  currency: string;
  formattedAmount: string;
}

export interface CustomerFormDto {
  // GENERIC
}

export interface FrontEndTextDto {

  area: string;
  name: string;
  label: string;
  description: string;

}

export enum CustomerInfoPageInternalType {
  other,
  dataProtection,
  termsOfUse
}

export interface FrontEndThemeColorDto {
  name: string;
  color: string;
  darkColor: string;
}

export interface RegularObjectDto {

  id: number;
  name: string;
  shortName: string;
  imageUrl: string;

}

export interface FormValueListEntryDto {

  key?: any;
  label?: string;
  technicalKey?: string;
  image?: string;
  description?: string;
  color?: string;
  backgroundColor?: string;
  priority?: number;
  uiClass?: any;
  parentKey?: any;

}

export enum ScheduleTypeInternal {
  whatsapp,
  call_me_back,
  call_us,
  bookings,
  none,
  vcard_qr // 👈 Add this
}

export interface ScheduleDto {

  scheduleTypeId: number;
  appointmentId?: number;

}

export interface ScheduleTypeDto {
  id: number;

  scheduleTypeInternal: ScheduleTypeInternal;

  uiPriority: number;
  uiLabel: string;
  uiMessage: string;
  uiMessageContact: string;
  defaultScheduleType: boolean;

  qrDocument: ImageDto;
}


export interface FormValueListDto {
  entries?: FormValueListEntryDto[];
}

export type FieldAccessEnum = "read" | "update" | "hidden";


export interface FormFieldDto {

  id: string;
  access?: FieldAccessEnum;
  isPrimaryKey?: boolean;
  namespace?: string;
  refreshFormOnChange?: boolean;
  order?: number;
  contextValue?: any;
  dataType?: string;
  referenceEntity?: string;
  uiListFreeDataEntry?: boolean;
  uiStringMinLength?: number;
  uiStringMaxLengthnumber?: number;
  uiStringCheckRegex?: string;
  uiNumberMinValuenumber?: string;
  uiNumberMaxValuenumber?: string;
  uiNumberSteps?: string;
  uiDoubleMinValuenumber?: string;
  uiDoubleMaxValuenumber?: string;
  uiLabel?: string;
  uiDescription?: string;
  uiLongDescription?: string;
  uiPlaceholder?: string;
  uiInputControl?: string;
  uiOutputControl?: string;
  uiFieldGroup?: string;
  uiMandatory?: boolean;
  uiReferenceDataObjectType?: string;
  relationship?: string;
  valueList?: FormValueListDto;
  uiNoValueList?: boolean;
  uiSearchHelp?: string;
  value?: any;

}


export interface FormDto {

  formFields: FormFieldDto[];

  formActions: any[]; // not used
  formFieldGroups: any[]; // not used

  formComplete: boolean;
  genericEntity: boolean;
  genericEntityFieldType: string;

  subForms: { [key: string]: string },
  entityName: string;
  objectType: string;

}

export interface EndUserFormFieldValueDto {
  key: any;
  label: string;
  priority: number;
}


export interface ExFormFieldDto {
  id: string;
  order?: number;
  uiInputControl?: string;
  uiLabel?: string;
  uiDescription?: string;
  uiMandatory?: boolean;
  value?: any;
  access?: FieldAccessEnum;
  hasValueList?: boolean;
  valueList?: EndUserFormFieldValueDto[];
}

export interface ExFormDto {
  id: number;
  uiName: string;
  uiDescription: string;
  formFields: ExFormFieldDto[];
}


export interface ImageDto {
  dataBase64: string;
  mimeType: string;
}

export enum ImageType {
  NONE,
  URL,
  USER
}

export interface DtoBasicDto {
  deviceInfo: DtoDeviceInfo
}

export interface DtoLoginRequest extends DtoBasicDto {
  email: string,
  password: string
}

export interface TokenRefreshRequestDto {
  refreshToken: string | undefined;
}

export interface DtoLoginResponse {
  accessToken: string,
  refreshToken: string,
  tokenType: string,
  expiryDuration?: number
}

export interface DtoLoginResponseFailed {
  data: string,
  success: boolean,
  timestamp: string,
  cause: string
}

export interface DtoDeviceInfo {
  deviceId: string,
  deviceType: "DEVICE_BROWSER"
  notificationToken: string
}

export interface ApiResponseDto {

  data?: string;
  success: boolean;
  timestamp?: string;
  cause?: string;
  path?: string;
  form?: FormDto;

}

export interface DtoChangePassword {
  oldPassword: string;
  newPassword: string;
  deviceInfo: DtoDeviceInfo;
}

export interface DtoUpdatePhone {
  newPhone: string;
  password: string;
}

export interface DtoUpdateEmail {
  newEmail: string;
  password: string;
}

export interface DtoDeactivateAccount {
  password: string;
}

// ex-login-pass-code-request.dto.ts
export interface ExLoginPassCodeRequestDto {
  passCode?: string | null; // Optional and can be null or blank
  deviceInfo: DtoDeviceInfo; // Required and must be valid
}

// ex-otp-login-initiate-request.ts
export interface ExOtpLoginInitiateRequest {
  loginType: EuOtpCodeLoginType;      // Enum or string union type
  referenceContact: string;
  deviceInfo: DtoDeviceInfo;
}

// eu-otp-code-login-type.enum.ts
export enum EuOtpCodeLoginType {
  EMAIL,
  MOBILE_PHONE
}

// ex-otp-login-initiate-response.ts
export interface ExOtpLoginInitiateResponse {
  errorOccurred: boolean;
  errorMessage: string;
}

// ex-otp-login-verify-request.ts
export interface ExOtpLoginVerifyRequest {
  loginType: EuOtpCodeLoginType;
  referenceContact: string;
  enteredOtpCode: string;
  deviceInfo: DtoDeviceInfo;
}

// ex-otp-login-verify-response.ts
export interface ExOtpLoginVerifyResponse {
  verified: boolean;
  passCode: string;
}
